// extracted by mini-css-extract-plugin
export var footer = "_nx-5";
export var fulfillmentInput = "_nx-0";
export var shipDateInput = "_nx-1";
export var shipmentModal = "_nx-2";
export var shipmentModalContent = "_nx-3";
export var tableContainer = "_nx-4";